import { render, staticRenderFns } from "./LocationButton.vue?vue&type=template&id=4afc64ee&scoped=true&"
import script from "./LocationButton.vue?vue&type=script&lang=js&"
export * from "./LocationButton.vue?vue&type=script&lang=js&"
import style0 from "./LocationButton.vue?vue&type=style&index=0&id=4afc64ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc64ee",
  null
  
)

export default component.exports